import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from '@/contexts/LanguageContext';
import { Toaster } from 'sonner';
import Layout from '@/components/Layout';
import Landing from '@/pages/Landing';
import Dashboard from '@/pages/Dashboard';
import ProjectWizard from '@/pages/ProjectWizard';
import ProjectDetail from '@/pages/ProjectDetail';
import ProjectAccess from '@/pages/ProjectAccess';
import SharedProjectView from '@/pages/SharedProjectView';
import ProjectFiles from '@/pages/ProjectFiles';
import ComplianceLibrary from '@/pages/ComplianceLibrary';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter basename='/backoffice'>
        <div className="App">
          <Routes>
            <Route path="/" element={<Layout />}>
              {/* Landing/Home */}
              <Route index element={<Landing />} />
              
              {/* Project Files Section */}
              <Route path="project-files" element={<ProjectFiles />} />
              
              {/* Compliance Library Section */}
              <Route path="compliance-library" element={<ComplianceLibrary />} />
              
              {/* Project Builder Section */}
              <Route path="projects" element={<Dashboard />} />
              <Route path="project/new" element={<ProjectWizard />} />
              <Route path="wizard" element={<ProjectWizard />} />
              <Route path="project/:id" element={<ProjectDetail />} />
            </Route>
            
            {/* Public/Shared routes (no layout) */}
            <Route path="/access" element={<ProjectAccess />} />
            <Route path="/view/:shareCode" element={<SharedProjectView />} />
            <Route path="/shared/:shareCode" element={<SharedProjectView />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;